import { GetUserResponseJSON } from "@performyard/service-contracts";

import { PYUseQueryOptions } from "../../../api/hooks/StandardQueryArguments";

import { fetchUser } from "../../../api/services/defs/internal-api";

export const getInternalApiUserQuery = (userID: string, options?: PYUseQueryOptions<GetUserResponseJSON>) => ({
	queryKey: ["InternalApiUser", userID],
	queryFn: () => fetchUser(userID),
	meta: {
		errorMessage: "There was an error getting user information.",
	},
	...options,
});
